<div>
  @for (menuItem of menuItems(); track menuItem) {
    <lbt-mobile-menu-item
      mat-dialog-close
      routerLinkActive
      #rla="routerLinkActive"
      [routerLink]="menuItem.route"
      [title]="menuItem.title"
      [icon]="menuItem.icon"
      [active]="rla.isActive"
    />
  }
</div>
<lbt-mobile-menu-item
  mat-dialog-close
  title="Sign out"
  icon="logout"
  (click)="logout()"
/>

<ng-template #signOutTmpl>
  <lbt-confirmation
    okText='Sign out'
    okType='primary'
    title="Sign out of your account?"
    [showHeader]="true"
    [showCloseIcon]="false"
    [noDivider]="true"
    [confirmContent]='signOutTextTmpl'>
  </lbt-confirmation>
</ng-template>

<ng-template #signOutTextTmpl>
  <lbt-text typography="body1" color="gray-12">
    You’ll be signed out from your account on this device.
  </lbt-text>
</ng-template>
